module.exports = __webpack_public_path__ + "static/media/filter.d82c0314.svg";